import { Form, Input, InputNumber } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { validateFileName } from '../../../common/Utils';
import { TestProjectWizardStore } from '../../stores';
import TestProjectTagsEditor from '../TestProjectTagsEditor';

type Props = {
    store: TestProjectWizardStore;
};

const ProjectNameStep: React.FC<Props> = ({ store }) => {
    return (
        <>
            <Form.Item
                label="Project name"
                name="name"
                rules={[
                    { required: true, message: 'Please input test project name!' },
                    { validator: (ruleObject, value) => validateFileName(ruleObject, value, 'Test project name') }
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item label="Tags" name="userTags">
                <TestProjectTagsEditor store={store} />
            </Form.Item>
            <Form.Item
                label="Default baseline fuzzy"
                name="defaultBaselineFuzzy"
                initialValue={100}
                rules={[{ required: true, message: 'Please input default baseline fuzzy!' }]}
            >
                <InputNumber min={0} max={100} style={{ width: 200 }} />
            </Form.Item>
        </>
    );
};

export default observer(ProjectNameStep);
